// extracted by mini-css-extract-plugin
module.exports = {"container":"_bV","card":"_bW","image":"_bX","imageContainer":"_bY","title":"_bZ","text":"_b0"};